import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useAlert } from '../../../hooks/useAlert';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { deleteOpportunities } from '../../../store/actions/actions';
import { routesNames } from '../../../utils/constants';
import { DialogActionButtons } from '../../dialogActionButtons/DialogActionButtons';
import { BootstrapDialog, dialogStyles, iconButtonStyles, useStyles } from './modalDetails.styles';
import { IProps } from './types';

export const ModalDetails = ({ name, open, setOpen }: IProps): JSX.Element => {
  const searchString = new URLSearchParams(window.location.search);
  const { setAlert } = useAlert();
  const id = searchString.get('id');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleSubmit = useCallback(():void => {
    deleteOpportunities(id)(dispatch).then(() => {
      setAlert('888', 'success');
      navigate(routesNames.main);
    });
  }, []);

  const actionProps = {
    cancel: 'No, leave it',
    submit: 'Yes, I want to cancel it',
    handleClose,
    handleSubmit,
  };

  return (
    <div>
      <BootstrapDialog
        className={classes.modal}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={dialogStyles}
          className={classes.modalMainTitle}
        >
          Cancel opportunity
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={iconButtonStyles}
          >
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className={classes.modalDescription}>
            {`This action cannot be undone. Are you sure you want to cancel “${name}” opportunity?`}
          </div>
        </DialogContent>
        <DialogActions>
          <DialogActionButtons {...actionProps} />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
